// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-question',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormQuestion {
  @Prop() questionLayout: string = 'horizontal-question';

  render() {
    return (
      <div class={`form_question ${this.questionLayout}`}>
        <slot />
      </div>
    );
  }
}
